/* =====================================================================
   PADDENSTOEL-KEUZEHULP · ENGINE
   Pas dit bestand normaal niet aan — alle vragen, producten en teksten
   staan in mushroom-finder-config.js.
   ===================================================================== */
(function () {
  'use strict';

  const ENT = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ENT[c]);
  const tpl = (s, v) => String(s || '').replace(/\{(\w+)\}/g, (_, k) => (v[k] != null ? v[k] : ''));
  const clone = (o) => JSON.parse(JSON.stringify(o || {}));
  const shopRoot = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const reducedMotion = () => window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getJSON = (url) =>
    fetch(url, { headers: { Accept: 'application/json' } }).then((r) => {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });

  /* ---------- Shopify-data ---------- */
  const cache = {};
  const getProduct = (handle) => {
    if (!handle) return Promise.resolve(null);
    if (!cache[handle]) {
      cache[handle] = getJSON(shopRoot() + 'products/' + encodeURIComponent(handle) + '.js').catch(() => {
        console.warn('[Keuzehulp] Product niet gevonden in Shopify: "' + handle + '"');
        return null;
      });
    }
    return cache[handle];
  };

  const sizedImg = (src, w) => {
    if (!src) return '';
    if (src.startsWith('data:')) return src;
    if (src.startsWith('//')) src = 'https:' + src;
    return src + (src.includes('?') ? '&' : '?') + 'width=' + w;
  };

  const formsOf = (def) => def.forms || (def.handle ? { standaard: def.handle } : {});

  /* Gewenste vorm → standaardvorm → overige vormen. Voorkeur voor wat op voorraad is. */
  async function resolveProduct(def, wanted) {
    const forms = formsOf(def);
    const order = [];
    const add = (k) => { if (k && forms[k] && !order.includes(k)) order.push(k); };
    add(wanted); add(def.defaultForm); Object.keys(forms).forEach(add);
    let fallback = null;
    for (const form of order) {
      const data = await getProduct(forms[form]);
      if (!data) continue;
      if (data.available) return { data, form };
      if (!fallback) fallback = { data, form };
    }
    return fallback;
  }

  /* ---------- Taal: Engelse teksten (mushroom-finder-en.js) over de Nederlandse heen ---------- */
  function mergeDeep(base, over) {
    if (over === undefined || over === null) return base;
    if (Array.isArray(base) && Array.isArray(over)) {
      return base.map((b, i) => (i < over.length ? mergeDeep(b, over[i]) : b));
    }
    if (base && typeof base === 'object' && !Array.isArray(base) && typeof over === 'object' && !Array.isArray(over)) {
      const out = Object.assign({}, base);
      Object.keys(over).forEach((k) => { out[k] = k in base ? mergeDeep(base[k], over[k]) : over[k]; });
      return out;
    }
    return over;
  }
  function configFor(el) {
    const base = window.MushroomFinderConfig;
    if (!base) return null;
    const lang = String(el.dataset.locale || document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
    const tr = window.MushroomFinderI18n && window.MushroomFinderI18n[lang];
    return tr ? mergeDeep(base, tr) : base;
  }

  /* ---------- Config-controle (zie browserconsole) ---------- */
  function validate(cfg) {
    const warn = (m) => console.warn('[Keuzehulp] ' + m);
    if (!cfg.flow[cfg.startNode]) warn('startNode "' + cfg.startNode + '" bestaat niet in flow.');
    Object.entries(cfg.flow).forEach(([id, node]) => {
      (node.options || []).forEach((o) => {
        if (!cfg.flow[o.next]) warn('Stap "' + id + '", knop "' + o.label + '": volgende stap "' + o.next + '" bestaat niet.');
        const s = o.set || {};
        [].concat(s.product || [], s.alt || []).forEach((k) => {
          if (!cfg.products[k]) warn('Stap "' + id + '", knop "' + o.label + '": product "' + k + '" staat niet in products.');
        });
      });
    });
    Object.entries(cfg.products).forEach(([k, p]) => {
      if (!cfg.categories[p.category]) warn('Product "' + k + '": onbekende categorie "' + p.category + '".');
    });
  }

  /* ---------- Keuzehulp ---------- */
  class Finder {
    constructor(root, cfg) {
      this.root = root;
      this.cfg = cfg || window.MushroomFinderConfig;
      this.t = this.cfg.text;
      this.stage = root.querySelector('[data-mf-stage]');
      this.card = root.querySelector('.mf__card');
      this.currency = root.dataset.currency || 'EUR';
      this.locale = root.dataset.locale || document.documentElement.lang || 'nl-NL';
      this.floating = root.dataset.mfMode === 'floating';
      this.token = 0;
      this.reset();
      root.addEventListener('click', (e) => this.onClick(e));
      this.renderIntro(false);
    }

    reset() { this.state = {}; this.history = []; this.picks = {}; this.nodeId = null; }

    money(cents) {
      try { return new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency }).format(cents / 100); }
      catch (e) { return '€ ' + (cents / 100).toFixed(2).replace('.', ','); }
    }

    formName(k) { return (this.t.forms && this.t.forms[k]) || k; }

    onClick(e) {
      const btn = e.target.closest('[data-mf-action]');
      if (!btn || !this.root.contains(btn)) return;
      const a = btn.dataset.mfAction;
      if (a === 'start') { this.history = [{ id: null, state: {} }]; this.nodeId = this.cfg.startNode; this.render(true); }
      else if (a === 'option') this.choose(Number(btn.dataset.index));
      else if (a === 'back') this.back();
      else if (a === 'restart') { this.reset(); this.renderIntro(true); }
    }

    choose(i) {
      const node = this.cfg.flow[this.nodeId];
      const opt = node && node.options && node.options[i];
      if (!opt) return;
      this.history.push({ id: this.nodeId, state: clone(this.state) });
      this.picks[this.nodeId] = i;
      Object.assign(this.state, clone(opt.set));
      this.nodeId = opt.next;
      this.render(true);
    }

    back() {
      const prev = this.history.pop();
      if (!prev || prev.id === null) { this.reset(); this.renderIntro(true); return; }
      this.nodeId = prev.id;
      this.state = prev.state;
      this.render(true);
    }

    render(focus) {
      const node = this.cfg.flow[this.nodeId];
      if (!node) { console.warn('[Keuzehulp] Onbekende stap: ' + this.nodeId); this.reset(); this.renderIntro(true); return; }
      if (node.type === 'result') this.renderResult(node, focus);
      else if (node.type === 'collection') this.renderCollection(node, focus);
      else this.renderQuestion(node, focus);
    }

    paint(html, focus) {
      const token = ++this.token;
      this.stage.innerHTML = html;
      this.stage.classList.remove('mf-enter');
      void this.stage.offsetWidth;
      this.stage.classList.add('mf-enter');
      if (focus) {
        const h = this.stage.querySelector('[data-mf-focus]');
        if (h) h.focus({ preventScroll: true });
        if (this.floating) {
          this.card.scrollTop = 0;
        } else {
          const r = this.card.getBoundingClientRect();
          if (r.top < 0 || r.top > window.innerHeight * 0.6) {
            this.card.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
          }
        }
      }
      return token;
    }

    /* ---------- Bouwstenen ---------- */
    topbar(node) {
      const hasStep = node.step && node.of;
      const pct = hasStep ? Math.round((node.step / node.of) * 100) : 100;
      const label = hasStep ? tpl(this.t.progress, { n: node.step, t: node.of }) : node.label || '';
      return (
        '<div class="mf__top">' +
          '<button type="button" class="mf__ghost" data-mf-action="back"><span aria-hidden="true">←</span> ' + esc(this.t.back) + '</button>' +
          '<span class="mf__count">' + esc(label) + '</span>' +
          '<button type="button" class="mf__ghost" data-mf-action="restart"><span aria-hidden="true">↺</span> ' + esc(this.t.restart) + '</button>' +
        '</div>' +
        '<div class="mf__track" role="progressbar" aria-label="' + esc(label) + '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>'
      );
    }

    note(n) {
      if (!n) return '';
      return '<div class="mf__note mf__note--' + esc(n.tone || 'info') + '">' +
        (n.title ? '<strong class="mf__note-title">' + n.title + '</strong>' : '') +
        (n.text ? '<p>' + n.text + '</p>' : '') + '</div>';
    }

    badge(def) {
      const c = this.cfg.categories[def.category] || { label: def.category || '', tone: 'total' };
      return '<span class="mf__badge mf__badge--' + esc(c.tone) + '"><span class="mf__badge-pre">' + esc(this.t.categoryPrefix) + '</span> ' + esc(c.label) + '</span>';
    }

    loading(node) {
      return '<div class="mf__screen">' + this.topbar(node) +
        '<div class="mf__body"><div class="mf__loading" role="status"><span class="mf__spinner" aria-hidden="true"></span>' + esc(this.t.loading) + '</div></div></div>';
    }

    /* ---------- Schermen ---------- */
    renderIntro(focus) {
      const i = this.cfg.intro;
      this.nodeId = null;
      this.paint(
        '<div class="mf__screen mf__screen--intro"><div class="mf__body mf__intro">' +
          '<div class="mf__hero" aria-hidden="true">' + (i.icon || '🍄') + '</div>' +
          '<h3 class="mf__q" tabindex="-1" data-mf-focus>' + i.title + '</h3>' +
          '<p class="mf__lead">' + i.text + '</p>' +
          (i.pills ? '<div class="mf__pills">' + i.pills.map((p) => '<span class="mf__pill mf__pill--' + esc(p.tone) + '">' + p.label + '</span>').join('') + '</div>' : '') +
          '<button type="button" class="mf__btn mf__btn--start" data-mf-action="start">' + this.t.start + '</button>' +
        '</div></div>',
        focus
      );
    }

    renderQuestion(node, focus) {
      const groups = [];
      node.options.forEach((o, i) => {
        const last = groups[groups.length - 1];
        if (!last || last.name !== o.group) groups.push({ name: o.group, items: [] });
        groups[groups.length - 1].items.push({ o, i });
      });
      const picked = this.picks[this.nodeId];
      const opts = groups.map((g) =>
        (g.name ? '<p class="mf__group">' + g.name + '</p>' : '') +
        '<div class="mf__options">' +
          g.items.map(({ o, i }) =>
            '<button type="button" class="mf__opt' + (o.tone ? ' mf__opt--' + esc(o.tone) : '') + (picked === i ? ' is-picked' : '') + '" data-mf-action="option" data-index="' + i + '">' +
              '<span class="mf__opt-icon" aria-hidden="true">' + (o.icon || '') + '</span>' +
              '<span class="mf__opt-text"><span class="mf__opt-label">' + o.label + '</span>' +
                (o.hint ? '<span class="mf__opt-hint">' + o.hint + '</span>' : '') + '</span>' +
            '</button>'
          ).join('') +
        '</div>'
      ).join('');

      this.paint(
        '<div class="mf__screen">' + this.topbar(node) +
          '<div class="mf__body">' + this.note(node.intro) +
            '<div class="mf__chat"><div class="mf__avatar" aria-hidden="true">' + (node.avatar || this.cfg.avatar || '🍄') + '</div>' +
              '<div class="mf__bubble"><h3 class="mf__q" tabindex="-1" data-mf-focus>' + node.question + '</h3>' +
              (node.hint ? '<p class="mf__hint">' + node.hint + '</p>' : '') + '</div></div>' +
            opts +
          '</div></div>',
        focus
      );
    }

    async renderResult(node, focus) {
      const s = this.state;
      const def = this.cfg.products[s.product] || { name: s.product || '', category: '' };
      /* alt mag één product zijn of een rij: de eerste die op voorraad is wordt getoond */
      const altKeys = [].concat(s.alt || []).filter((k) => this.cfg.products[k]);
      const token = this.paint(this.loading(node), false);

      const [hit, altHits] = await Promise.all([
        def.forms || def.handle ? resolveProduct(def, s.form) : null,
        Promise.all(altKeys.map((k) => resolveProduct(this.cfg.products[k], s.form)))
      ]);
      if (token !== this.token) return; // bezoeker is intussen verder geklikt
      const altIdx = altHits.findIndex((h) => h && h.data.available);
      const altKey = altIdx > -1 ? altKeys[altIdx] : null;
      const altDef = altKey ? this.cfg.products[altKey] : null;
      const altHit = altIdx > -1 ? altHits[altIdx] : null;

      const p = hit && hit.data;
      const url = p ? p.url : shopRoot() + 'search?q=' + encodeURIComponent(def.name);
      const img = p && p.featured_image ? sizedImg(p.featured_image, 640) : '';
      const cents = p ? (p.price_min != null ? p.price_min : p.price) : 0;
      const price = cents > 0 ? (p.price_varies ? esc(this.t.from) + ' ' : '') + this.money(cents) : '';
      const soldOut = p && !p.available;

      const reasons = (s.reasons || []).slice();
      let formNote = '';
      const wanted = s.form && s.form !== 'none' ? s.form : null;
      if (wanted && hit && def.forms) {
        if (hit.form === wanted) reasons.push(this.t.formMatch);
        else formNote = tpl(this.t.formFallback, { wanted: this.formName(wanted), shown: this.formName(hit.form) });
      }

      let alt = '';
      if (altDef) {
        const ap = altHit && altHit.data;
        const aurl = ap ? ap.url : shopRoot() + 'search?q=' + encodeURIComponent(altDef.name);
        const aimg = ap && ap.featured_image ? sizedImg(ap.featured_image, 160) : '';
        alt =
          '<a class="mf__alt" href="' + esc(aurl) + '">' +
            (aimg ? '<img class="mf__alt-img" src="' + esc(aimg) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="mf__alt-img mf__alt-img--ph" aria-hidden="true">' + (altDef.icon || '🍄') + '</span>') +
            '<span class="mf__alt-text"><span class="mf__alt-label">' + esc(this.t.altPrefix) + ' <strong>' + altDef.name + '</strong></span>' +
            '<span class="mf__alt-why">' + (s.altWhy || altDef.short || '') + '</span></span>' +
            '<span class="mf__alt-arrow" aria-hidden="true">→</span>' +
          '</a>';
      }

      const html =
        '<div class="mf__screen">' + this.topbar(node) +
        '<div class="mf__body mf__result">' +
          '<h3 class="mf__match" tabindex="-1" data-mf-focus><span aria-hidden="true">' + (def.icon || '🍄') + '</span> ' + esc(this.t.matchPrefix) + ' ' + def.name + '</h3>' +
          '<a class="mf__product" href="' + esc(url) + '">' +
            '<span class="mf__media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="320" height="320" loading="lazy">' : '<span class="mf__media-ph" aria-hidden="true">' + (def.icon || '🍄') + '</span>') + '</span>' +
            '<span class="mf__info">' + this.badge(def) +
              '<span class="mf__ptitle">' + esc(p ? p.title : def.name) + '</span>' +
              (price || soldOut ? '<span class="mf__price">' + price + (price && soldOut ? ' · ' : '') + (soldOut ? '<span class="mf__soldout">' + esc(this.t.soldOut) + '</span>' : '') + '</span>' : '') +
            '</span>' +
          '</a>' +
          (def.pitch ? '<p class="mf__pitch">' + def.pitch + '</p>' : '') +
          (reasons.length ? '<p class="mf__why-title">' + esc(this.t.whyTitle) + '</p><ul class="mf__why">' + reasons.map((r) => '<li>' + r + '</li>').join('') + '</ul>' : '') +
          (formNote ? '<p class="mf__formnote">' + esc(formNote) + '</p>' : '') +
          this.note(this.cfg.notices[node.notice || s.notice]) +
          '<a class="mf__btn" href="' + esc(url) + '">' + tpl(this.t.view, { name: def.name }) + '</a>' +
          alt +
        '</div></div>';

      this.paint(html, focus);
      this.root.dispatchEvent(new CustomEvent('mushroomfinder:result', {
        bubbles: true, detail: { product: s.product, form: hit && hit.form, handle: p && p.handle, alternative: altKey }
      }));
    }

    async renderCollection(node, focus) {
      const token = this.paint(this.loading(node), false);
      /* Bron: vaste lijst handles (node.handles) of een Shopify-collectie (node.collection) */
      let items = [];
      if (node.handles) {
        const list = await Promise.all(node.handles.map(getProduct));
        items = list.filter(Boolean).map((p) => ({
          title: p.title, url: p.url, img: p.featured_image, available: p.available,
          cents: p.price_min != null ? p.price_min : p.price, varies: p.price_varies
        }));
      } else if (node.collection) {
        try {
          const d = await getJSON(shopRoot() + 'collections/' + encodeURIComponent(node.collection) + '/products.json?limit=' + (node.limit || 6));
          items = (d.products || []).map((p) => {
            const v = p.variants || [];
            const prices = v.map((x) => parseFloat(x.price)).filter((n) => !isNaN(n));
            const min = prices.length ? Math.min.apply(null, prices) : 0;
            return {
              title: p.title, url: shopRoot() + 'products/' + p.handle, img: p.images && p.images[0] && p.images[0].src,
              available: v.some((x) => x.available), cents: Math.round(min * 100), varies: prices.some((x) => x !== min)
            };
          });
        } catch (e) {
          console.warn('[Keuzehulp] Collectie niet gevonden: "' + node.collection + '"');
        }
      }
      if (token !== this.token) return;

      const cards = items.map((p) => {
        const price = p.cents > 0 ? (p.varies ? esc(this.t.from) + ' ' : '') + this.money(p.cents) : '';
        const sold = !p.available ? '<span class="mf__soldout">' + esc(this.t.soldOut) + '</span>' : '';
        return '<a class="mf__mini" href="' + esc(p.url) + '">' +
          '<span class="mf__mini-media">' + (p.img ? '<img src="' + esc(sizedImg(p.img, 320)) + '" alt="" width="160" height="160" loading="lazy">' : '<span class="mf__media-ph" aria-hidden="true">🔬</span>') + '</span>' +
          '<span class="mf__mini-title">' + esc(p.title) + '</span>' +
          (price || sold ? '<span class="mf__mini-price">' + price + (price && sold ? ' · ' : '') + sold + '</span>' : '') +
        '</a>';
      }).join('');

      const collUrl = node.ctaUrl || (node.collection ? shopRoot() + 'collections/' + encodeURIComponent(node.collection) : shopRoot() + 'collections/all');
      this.paint(
        '<div class="mf__screen">' + this.topbar(node) +
        '<div class="mf__body mf__result">' +
          '<h3 class="mf__match" tabindex="-1" data-mf-focus>' + (node.title || '') + '</h3>' +
          this.note(node.intro) +
          (cards ? '<div class="mf__grid">' + cards + '</div>' : '<p class="mf__hint">' + esc(this.t.emptyCollection) + '</p>') +
          this.note(this.cfg.notices[node.notice]) +
          (node.cta ? '<a class="mf__btn" href="' + esc(collUrl) + '">' + node.cta + '</a>' : '') +
        '</div></div>',
        focus
      );
    }
  }

  /* ---------- Zwevende chatknop ---------- */
  function initFloating(root) {
    const launcher = root.querySelector('[data-mf-launcher]');
    const panel = root.querySelector('[data-mf-panel]');
    const teaser = root.querySelector('[data-mf-teaser]');
    if (!launcher || !panel) return;
    const isMobile = () => window.matchMedia && matchMedia('(max-width: 640px)').matches;
    const remember = () => { try { sessionStorage.setItem('mf-teaser-seen', '1'); } catch (e) {} };
    const hideTeaser = () => { if (teaser) teaser.hidden = true; };

    const open = () => {
      if (!panel.hidden) return;
      panel.hidden = false;
      root.classList.add('mf--open');
      launcher.setAttribute('aria-expanded', 'true');
      hideTeaser(); remember();
      if (isMobile()) document.documentElement.classList.add('mf-lock');
      const f = panel.querySelector('[data-mf-focus]') || panel.querySelector('button');
      if (f) f.focus({ preventScroll: true });
      root.dispatchEvent(new CustomEvent('mushroomfinder:open', { bubbles: true }));
    };
    const close = (returnFocus) => {
      if (panel.hidden) return;
      panel.hidden = true;
      root.classList.remove('mf--open');
      launcher.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('mf-lock');
      if (returnFocus !== false) launcher.focus({ preventScroll: true });
    };

    launcher.addEventListener('click', () => (panel.hidden ? open() : close()));
    root.querySelectorAll('[data-mf-close]').forEach((b) => b.addEventListener('click', () => close()));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

    /* Teaser-wolkje, één keer per bezoek */
    if (teaser) {
      const delay = Number(root.dataset.teaserDelay || 0);
      let seen = false;
      try { seen = sessionStorage.getItem('mf-teaser-seen') === '1'; } catch (e) {}
      if (delay > 0 && !seen) setTimeout(() => { if (panel.hidden) teaser.hidden = false; }, delay * 1000);
      teaser.addEventListener('click', (e) => {
        if (e.target.closest('[data-mf-teaser-close]')) { hideTeaser(); remember(); } else open();
      });
    }

    /* Elke link naar #keuzehulp opent de chat (bijv. een knop in je menu of op een productpagina) */
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href$="#keuzehulp"]');
      if (a) { e.preventDefault(); open(); }
    });
    if (location.hash === '#keuzehulp') open();

    /* Thema-editor: sectie aanklikken opent het venster */
    const section = root.closest('.shopify-section') || root;
    document.addEventListener('shopify:section:select', (e) => { if (e.target === section) open(); });
    document.addEventListener('shopify:section:deselect', (e) => { if (e.target === section) close(false); });
  }

  /* ---------- Start ---------- */
  let validated = false;
  function showError(el, msg) {
    const st = el.querySelector('[data-mf-stage]');
    if (st) st.innerHTML = '<div class="mf__body"><div class="mf__note mf__note--warn"><strong class="mf__note-title">De keuzehulp kon niet laden</strong><p>' + msg + '</p></div></div>';
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-mf-root]').forEach((el) => {
      if (el.__mf) return;
      const cfg = configFor(el);
      el.__mf = true;
      /* Knop altijd laten werken, ook als er hieronder iets misgaat */
      if (el.dataset.mfMode === 'floating') initFloating(el);
      if (!cfg) {
        console.warn('[Keuzehulp] mushroom-finder-config.js is niet geladen.');
        showError(el, 'Het bestand <strong>mushroom-finder-config.js</strong> ontbreekt in assets of bevat een fout. Controleer de bestandsnaam en plak de inhoud opnieuw.');
        return;
      }
      try {
        if (!validated) { validate(cfg); validated = true; }
        el.__mf = new Finder(el, cfg);
      } catch (err) {
        console.error('[Keuzehulp]', err);
        showError(el, 'Foutmelding: ' + esc(err && err.message));
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
